import React from 'react';

/**
 * Error Boundary component that catches JavaScript errors anywhere in the
 * child component tree and displays a fallback UI instead of crashing.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught an error:', error.message || error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div style={{
          padding: '2rem',
          margin: '1rem',
          borderRadius: '8px',
          backgroundColor: document.documentElement.classList.contains('dark') ? '#2a1a1a' : '#fef2f2',
          border: '1px solid #fecaca',
        }}>
          <h2 style={{ color: document.documentElement.classList.contains('dark') ? '#fca5a5' : '#991b1b', marginBottom: '0.5rem' }}>
            Something went wrong
          </h2>
          <p style={{ color: document.documentElement.classList.contains('dark') ? '#fecaca' : '#7f1d1d', marginBottom: '1rem' }}>
            An unexpected error occurred. Please try again.
          </p>
          <button
            onClick={this.handleReset}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Try Again
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ marginTop: '1rem', color: document.documentElement.classList.contains('dark') ? '#fecaca' : '#7f1d1d' }}>
              <summary>Error Details</summary>
              <pre style={{ overflow: 'auto', fontSize: '0.75rem', marginTop: '0.5rem' }}>
                {this.state.error.toString()}
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
